import { createContext, useContext } from 'react'
import SpinnerBlock from '@components/spinner/SpinnerBlock'
import Icon from '@components/shared/Icon'
import useT from '@hooks/useTranslation'

import styles from 'styles/payment/PriceTable.module.css'

const TableContext = createContext({})

function PriceTable () {
    const { table: { items }} = useContext(TableContext)
    if (!items) return <SpinnerBlock height={300} />

    return (
        <table className={styles.table}>
            <PriceTableHead />
            <PriceTableBody />
            <PriceTableClearButton />
        </table>
    )
}

function PriceTableHead () {
    const { table: { columnHeads }} = useContext(TableContext)
    return (
        <thead>
            <tr>{ columnHeads
                .map((text, i) => <th key={i}>{useT(text)}</th>) }</tr>
        </thead>
    )
}

function PriceTableBody () {
    const { table: { rowHeads, rowsAvailable, items }} = useContext(TableContext)
    const rows = Object.keys(items)
    return (
        <tbody>
            { rows
                .map((row, i) =>
                    <PriceTableRow
                        key={i}
                        name={row}
                        head={rowHeads[i]}
                        items={items[row]}
                        available={typeof rowsAvailable === 'boolean'
                            ? rowsAvailable
                            : rowsAvailable[i]} />) }
        </tbody>
    )
}

function PriceTableRow ({ head, name, items, available }) {
    return (
        <tr className={available
            ? undefined
            : styles.unavailable}>

            { head && <td>{useT(head)}</td> }

            { items.map((item, i) =>
                <PriceTableItem
                    key={i}
                    row={name}
                    item={item}
                    available={available} />) }
        </tr>
    )
}

function PriceTableItem ({ row, item, available }) {
    const { table: { itemDisplayRule, itemClick, itemsSelected }} = useContext(TableContext)
    const isSelected = itemsSelected
        ? item._id in itemsSelected
        : false

    return <td
        onClick={available
            ? itemClick
                ? () => itemClick(row, item)
                : undefined
            : undefined}

        className={isSelected
            ? styles.selected
            : styles.item}>

            {itemDisplayRule(item)}

        </td>
}

function PriceTableClearButton () {
    const { table: { clear }} = useContext(TableContext)
    if (!clear) return null
    return <tfoot className={styles.clear} onClick={clear}>
        <tr><td><Icon>close</Icon></td></tr></tfoot>
}

export default PriceTable
export { TableContext }